import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Users, Heart } from 'lucide-react';
import { Button } from "@/components/ui/button";

export default function RecipeCard({ recipe, isFavorite, onToggleFavorite, onClick, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ delay }}
      onClick={onClick}
      className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow"
    >
      {recipe.image_url ? (
        <div className="h-36 sm:h-48 overflow-hidden">
          <img src={recipe.image_url} alt={recipe.title} className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="h-36 sm:h-48 bg-gradient-to-br from-green-100 to-emerald-100 flex items-center justify-center">
          <span className="text-5xl sm:text-6xl">🍳</span>
        </div>
      )}

      <div className="p-3 sm:p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-semibold text-gray-900 text-base sm:text-lg leading-tight">{recipe.title}</h3>
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.stopPropagation();
              onToggleFavorite();
            }}
            className="rounded-full -mt-1"
          >
            <Heart className={`w-5 h-5 ${isFavorite ? 'fill-red-500 text-red-500' : 'text-gray-400'}`} />
          </Button>
        </div>

        {recipe.description && (
          <p className="text-sm text-gray-600 mb-3 line-clamp-2">{recipe.description}</p>
        )}

        <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
          {recipe.prep_time && (
            <div className="flex items-center gap-1">
              <Clock className="w-4 h-4" />
              <span>{recipe.prep_time} min</span>
            </div>
          )}
          {recipe.servings && (
            <div className="flex items-center gap-1">
              <Users className="w-4 h-4" />
              <span>{recipe.servings} porciones</span>
            </div>
          )}
        </div>

        {recipe.health_tags && recipe.health_tags.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {recipe.health_tags.slice(0, 3).map((tag, index) => (
              <span key={index} className="px-2 py-0.5 bg-green-50 text-green-700 text-xs rounded-full">
                {tag}
              </span>
            ))}
            {recipe.health_tags.length > 3 && (
              <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">
                +{recipe.health_tags.length - 3}
              </span>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
}